import React, { useState } from 'react';
import { Star } from 'lucide-react';

export default function StarRating({
    label,
    value = 0,
    onChange,
    error,
    max = 5,
    className = ''
}) {
    const [hover, setHover] = useState(0);

    return (
        <div className={`flex flex-col gap-1.5 ${className}`}>
            {label && (
                <label className="text-sm font-medium text-gray-700">
                    {label}
                </label>
            )}
            <div className="flex gap-1">
                {[...Array(max)].map((_, index) => {
                    const ratingValue = index + 1;
                    return (
                        <button
                            type="button"
                            key={ratingValue}
                            className={`focus:outline-none transition-colors duration-200 p-1 -ml-1 first:ml-0 rounded-full hover:bg-gray-50`}
                            onClick={() => onChange(ratingValue)}
                            onMouseEnter={() => setHover(ratingValue)}
                            onMouseLeave={() => setHover(0)}
                        >
                            <Star
                                className={`w-8 h-8 transition-colors duration-200 ${ratingValue <= (hover || value)
                                        ? "text-yellow-400 fill-yellow-400"
                                        : "text-gray-300"
                                    }`}
                            />
                        </button>
                    );
                })}
            </div>
            {error && (
                <span className="text-sm text-red-500">{error.message}</span>
            )}
        </div>
    );
}
